<header class="modal-header px-4 bg-white border-bottom-0">
  <button type="button" class="close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body pt-0">
  <div>
    <div class="row mb-4">
      <div class="col-12 text-center">
        <img
          width="120px"
          height="120px"
          src="../../../../../../../assets/icons/alert_black_icon.png"
        />
      </div>
      <div class="col-12 text-center">
        <h2 class="h4 font-weight-bold my-3">
          ¿Seguro de desasociar el usuario depositario?
        </h2>
      </div>
    </div>
    <footer class="text-center p-1">
      <button
        class="btn btn-outline-primary modal-tipo-rnt-btn-inicio-outline mr-3 border-0"
        (click)="dismiss()"
      >
        Cancelar
      </button>
      <button (click)="sendForm()" class="btn btn-primary m-auto">
        Desasociar
      </button>
    </footer>
  </div>
</section>
